import Table from 'components/Table/Table';
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import VerticalLinearStepper from "views/Dashboard/SignatureEnrollments/Stepper/VerticalStepper";
import HorizontalStepperForEnrollment from "views/Dashboard/SignatureEnrollments/Stepper/HorizontalStepper";
import CloseIcon from '@material-ui/icons/Close';
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import ThriveSignatureRequests from 'apis/ThriveSignatureRequest/ThriveSignatureRequest';
import context from "context/context";
import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import useDebounce from 'helpers/useDebounce';
import Loader from "components/Loader/Loader";

import Card from '@material-ui/core/Card';
import { toast } from 'react-toastify';
import {
    Tabs,
    Tab,
    Box,
    withStyles,
    TextField,
    IconButton,
    Dialog,
    DialogContent,
    DialogContentText,
    InputAdornment,
    Button,
    Badge,
    Grid,
    MenuItem,
    Typography
} from "@material-ui/core";
import { blockInvalidChar } from "helpers/blockInvalidChar";
import { Styles } from "./styles";
import searchIcon from "assets/img/Search_Icon.png";
import { emailValidate } from "helpers/validateRules/auth";
import {
    DatePicker,
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { enUS, fr } from "date-fns/locale";
import { useTranslation } from 'react-i18next';
import { pdf } from '@react-pdf/renderer';
import EnrollmentSignaturePDF from './EnrollmentSignaturePDF';
import PreviewToPdf from "./EnrollmentPreview";
import { CSVLink } from "react-csv";
import { exportHeaders } from './export';
import { Modal, Backdrop, Fade } from '@material-ui/core';


// custom TextField
const CssTextField = withStyles({
    root: {
        '& label.Mui-focused': {
            color: '##D3D3D3',
        },
        '& .MuiFormLabel-root': {
            color: '#707070',
        },
        '& .MuiInputBase-input': {
            color: '#707070',
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: '#707070!important',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#707070!important',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#707070',
            },
            '&:hover fieldset': {
                borderColor: '#707070',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#707070',
            },
            '&.MuiOutlinedInput-root': {
                borderRadius: 20,
            },
            '&.MuiOutlinedInput-root': {
                marginTop: 0,
                borderRadius: 20,
                background: '#ededed',
            },
        },
    },
})(TextField);

const formFields = [
    { label: "Henry Schein Account Number", key: "henry_schein_account_number" },
    { label: "Title", key: "title" },
    { label: "Practice Owner Name", key: "practice_owner_name" },
    { label: "Point of Contact", key: "point_of_contact" },
    { label: "Office Number", key: "office_number" },
    { label: "Preferred Contact Number", key: "preferred_contact_number" },
    { label: "Email", key: "email" },
    { label: "Practice Name", key: "practice_name" },
    { label: "Street Address", key: "street_address" },
    { label: "City", key: "city" },
    { label: "State", key: "state" },
    { label: "Zip Code", key: "zipcode" },
    { label: "Select Subscription Plan", key: "subscription_plan" },
];

function AllRequests({ readOnlyDialogObj, setReadOnlyDialogObj, setCreateDialogObj, setEditEmailField }) {
    const [offset, setOffset] = useState(1);
    const [count, setCount] = useState(0);
    const [searchValue, setSearchValue] = useState('');
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [resLoaded, setResLoaded] = useState(false);
    const { t, i18n } = useTranslation();
    const { getsignature, searchAPI, filter, enrollmentExport } = ThriveSignatureRequests();
    const { dispatch, state } = useContext(context);
    const [fitervalue, setfiterValue] = useState("");
    const [open, setOpen] = useState(false);
    const [previewData, setPreviewData] = useState({});
    const [filterCard, setFilterCard] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [exportData, setExportData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [imageType, setImageType] = useState('');
    const classes = Styles();
    const [states, setStates] = useState({
        historyLoader: false,
        clearSearch: false,
        status: "",
        plan: "",
        filter: false
    });

    const searchBounceValues = useDebounce(() => {
        return searchValue === '' ? '' : searchValue;
    });

    useEffect(() => {
        // Optional: update pathname globally
        // dispatch({ type: 'SET_PATHNAME', payload: ['HOME', 'ADMIN', 'RESPONSE'] });
        handleGet();
    }, []);

    useEffect(() => {
        if (states?.clearSearch) {
            setStates((prev) => ({ ...prev, clearSearch: false }));
            return;
        }

        if (searchBounceValues && searchBounceValues.length > 0) {
            handleSearch();
        } else if (states?.filter) {
            handleFilter();
        } else {
            handleGet();
        }
    }, [searchBounceValues, offset, states?.filter]);

    // useEffect(() => {

    //   if (!states?.clearSearch) {
    //     if (searchBounceValues && searchBounceValues.length > 0) {
    //       handleSearch();
    //     } else {
    //       handleGet();
    //     }
    //   } else {
    //     setStates({ clearSearch: false });
    //   }
    // }, [searchBounceValues, offset]);

    const handlePagination = (value) => {
        setOffset(value);
    };

    const handleGet = async () => {
        setLoading(true);
        try {
            let values;
            values = {
                offset: (offset - 1) * 10,
                limit: 10,
            };

            const res = await getsignature(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
        } catch (e) {
            console.error('Get error:', e);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = async () => {
        setLoading(true);
        try {
            const values = {
                search: searchValue,
                offset: (offset - 1) * 10,
                limit: 10
            };
            const res = await searchAPI(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
        } catch (e) {
            console.error('Search error:', e);
        } finally {
            setLoading(false);
        }
    };

    const getPlanName = (plan) => {
        if (!plan) return "-";
        const index = plan.indexOf(":");
        const substring = index === -1 ? plan : plan.substring(0, index);
        return substring.split(" ")[0].trim();
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handlepdfClose = () => {
        setOpenModal(false);
    }

    const handleFilter = async () => {
        try {
            if (!states.status && !states.plan) return;

            const values = {
                offset: (offset - 1) * 10,
                limit: 10,
                ...(states.status && { status: states.status }),
                ...(states.plan && { plan: states.plan }),
            };

            dispatch({ type: 'SET_LOADING', payload: true });
            const res = await filter(values);

            if (res) {
                setData(res.data);
                setCount(res.count);
                setFilterCard(false);
                dispatch({ type: 'SET_LOADING', payload: false });
            }
        } catch (e) {
            console.log(e);
        }
    };


    const handleExport = async () => {
        try {
        let values = {};


        // 🎯 Priority 1: Search-based export
        if (searchValue) {
            values = { ...values, search: searchValue };
        }
        // 🎯 Priority 2: Filter-based export
        if (states.status || states.plan) {
            values = {
                ...values,
                ...(states.status && { status: states.status }),
                ...(states.plan && { plan: states.plan }),

            };
        }


        dispatch({ type: "SET_LOADING", payload: true });
        setIsLoading(true);
        let res = await enrollmentExport(values);
        if (res && res.data) {
            const formattedData = res.data.map(item => ({
              ...item,
              hsd_sync_date: item.hsd_sync_date
                ? moment(item.hsd_sync_date).format("YYYY-MM-DD") // format if date exists
                : "-",
                segment_code: item.segment_code? item.segment_code: null,
                rejected_reason: item.rejected_reason? item.rejected_reason: null,
                trial_period:item.trial_period? item.trial_period: null,
            }));
      
            setExportData(formattedData);
            dispatch({ type: "SET_LOADING", payload: false });
            setIsLoading(false);
      
            if (formattedData.length === 0) {
              toast.success(t("No Data Found"), { toastId: "no-report-date" });
              return false;
            }
      
            return true;
          }
        } catch (e) {
          console.log(e);
          dispatch({ type: "SET_LOADING", payload: false });
        }
      };
 
        // if (res && res.data) {
        //     const formattedData = res.data.map(item => ({
        //         ...item,
        //         hsd_sync_date: item.hsd_sync_date
        //           ? moment(item.hsd_sync_date).format("YYYY-MM-DD") // format if date exists
        //           : "-", // show '-' if null/empty
        //       }));
          
        //     setExportData(res.data);
        //     dispatch({ type: "SET_LOADING", payload: false });
        //     setIsLoading(false);
        //     if (res.data.length === 0) {
        //         toast.success(t("No Data Found"), { toastId: "no-report-date" });
        //         return false;
        //     }
        //     return true;
        // }
    //} 
    // catch (e) {
    //     console.log(e);
    //     dispatch({ type: "SET_LOADING", payload: false });
    // }
    // };

    return (
        <React.Fragment>
            <Grid container className={classes.root}>
                <Grid item xs={12} sm={12} lg={12} style={{ position: 'relative' }}>
                    <CssTextField
                        placeholder={'Search for Shipto'}
                        type={'text'}
                        variant='outlined'
                        onKeyDown={blockInvalidChar}
                        className={classes.searchInput}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position='end'>
                                    {searchValue.length > 0 ? (
                                        <CloseOutlinedIcon
                                            className={classes.searchInputIcon}
                                            onClick={() => {
                                                setSearchValue('');
                                                setOffset(1);
                                                handleGet();
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src={searchIcon}
                                            alt=''
                                            width='20px'
                                            className={classes.searchInputIcon}
                                        />
                                    )}
                                </InputAdornment>
                            )
                        }}
                        value={searchValue}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            setOffset(1);
                            if (e.target.value.length === 0) {
                                handleGet();
                            }
                        }}
                    />

                    <Button
                        className={`${classes.filterBtn} dash-1-filter-btn`}
                        onClick={() => {
                            setFilterCard(!filterCard);
                            if (!states.filter) {
                                setStates({ status: '', plan: '' });
                            }
                        }}
                    >


                        {t('Filter')}
                        {states.filter && (
                            <Badge style={{ marginTop: '-40px' }}
                                badgeContent={count == 0 ? '' : count}
                                classes={{ badge: classes.badge }}
                                max={999}
                            >
                                {/* <FilterListIcon /> */}
                            </Badge>
                        )}
                    </Button>

                    {(state?.userInfo?.role_id === 3 || state?.userInfo?.role_id === 13 || state?.userInfo?.role_id === 10) && (
                    <Button
                        className={`${classes.filterBtn} dash-1-filter-btn`}
                        onClick={() => setCreateDialogObj({ open: true })}
                    >
                        Create New Request
                    </Button>
                    )}

                    <CSVLink
                        id="csv"
                        data={exportData}
                        headers={exportHeaders}
                        filename={
                            `Enrollments` +
                            " " +
                            moment(new Date()).format("MM-DD-YYYY,h:mm A") +
                            ".csv"
                        }
                        className={classes.CSVlink}
                    />
                    <Button
                        disabled={isLoading}
                        className={`${classes.filterBtn} dash-1-filter-btn`}
                        onClick={async () => {
                            
                            let res = await handleExport();
                            if (res) {
                                document.getElementById("csv").click();
                            }
                        }}
                    >
                         {isLoading ? (
              <div class="snippet" style={{ marginLeft: 25 }}>
                <div class="stage">
                  <div class="dot-typing-e"></div>
                </div>
              </div>
            ) :
            t('Export')
            }
                        
                    </Button>
                    <Button
                        className={`${classes.filterBtn} dash-1-filter-btn`}
                        onClick={() => setEditEmailField({ isModalOpen: true })}
                    >
                        Edit Email
                    </Button>
                </Grid>
            </Grid>


            {filterCard && (
                <div className={classes.filterCardDiv}>
                    <Grid container spacing={0}>
                        <Grid item xs={12} style={{ float: 'right' }}>
                            <Card className={classes.filterCard}>
                                <Grid
                                    container
                                    spacing={1}
                                    className={classes.filterCardGridContainer}
                                >
                                    {/* Status */}
                                    <Grid
                                        item
                                        xs={4}
                                        sm={4}
                                        className={classes.filterCardGrid}
                                        style={{ padding: '5px 10px 10px 15px' }}
                                    >
                                        <TextField
                                            id="Status"
                                            label={t('Status')}
                                            select
                                            fullWidth
                                            type="text"
                                            value={states?.status}
                                            onChange={(e) => {
                                                setStates({
                                                    ...states, // keep previous values
                                                    status: e.target.value,
                                                });
                                            }}
                                        >
                                            <MenuItem value="Inprogress">{t('Inprogress')}</MenuItem>
                                            <MenuItem value="Processed">{t('Processed')}</MenuItem>
                                            <MenuItem value="Rejected">{t('Rejected')}</MenuItem>
                                        </TextField>
                                    </Grid>

                                    {/* Plan */}
                                    <Grid
                                        item
                                        xs={4}
                                        sm={4}
                                        className={classes.filterCardGrid}
                                        style={{ padding: '5px 10px 10px 10px' }}
                                    >
                                        <TextField
                                            id="Plan"
                                            label={t('Plan')}
                                            select
                                            fullWidth
                                            type="text"
                                            value={states?.plan}
                                            onChange={(e) => {
                                                setStates({
                                                    ...states, // keep previous values
                                                    plan: e.target.value,
                                                });
                                            }}
                                        >
                                            <MenuItem value="Yearly">{t('Yearly')}</MenuItem>
                                            <MenuItem value="Monthly">{t('Monthly')}</MenuItem>
                                            <MenuItem value="Trial">{t('Trial')}</MenuItem>
                                            <MenuItem value="Unlocked">{t('Unlocked')}</MenuItem>
                                        </TextField>
                                    </Grid>

                                    {/* Buttons */}
                                    <Grid
                                        item
                                        xs={4}
                                        sm={4}
                                        className={classes.filterCardBtnGrid}
                                        style={{ padding: 10, display: "flex", justifyContent: "space-between" }}
                                    >
                                        <Button
                                            className={classes.filterCardApplyBtn}
                                            style={{
                                                fontSize: 15,
                                                //   height: 35,
                                                marginTop: 0,
                                            }}
                                            onClick={() => {
                                                if (!states.status && !states.plan) {
                                                    toast.error('Please select any one of the fields', {
                                                        toastId: 'filter-empty',
                                                    });
                                                    return;
                                                }
                                                setSearchValue('');
                                                setStates((prev) => ({
                                                    ...prev,
                                                    filter: true,
                                                }));
                                                setOffset(1);
                                                setCount(0);
                                                handleFilter();
                                            }}
                                        >
                                            {t('Apply')}
                                        </Button>

                                        {states.filter && (
                                            <Button
                                                className={classes.filterCardResetBtn}
                                                onClick={() => {
                                                    setStates({
                                                        filter: false,
                                                        status: '',
                                                        plan: '',
                                                    });
                                                    setFilterCard(false);
                                                    if (offset === 1) {
                                                        handleGet();
                                                    } else {
                                                        setOffset(1);
                                                    }
                                                }}
                                            >
                                                {t('Reset')}
                                            </Button>
                                        )}
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    </Grid>
                </div>
            )}

            <Loader loading={state?.loading} top='15%'>
                <Grid className={classes.tableDownInResponsive}>
                    <Grid item xs={12}>
                        {loading ? (
                            <div
                                style={{
                                    height: "25vh",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <h2>{t('Loading...')}</h2>
                            </div>

                        ) :
                            <Table
                                headings={['Shipto', 'Account Name', 'City', 'Email', 'Segment', 'Plan', 'Trial Period','Request Date', 'Status', 'Document', 'HSD Sync', 'View']}
                                data={data.map((d, i) => [
                                    d?.henry_schein_account_number,
                                    d?.practice_name,
                                    d?.city,
                                    d?.email,
                                    d?.segment_code || "-",
                                    <span>{getPlanName(d?.subscription_plan)}</span>,
                                    d?.trial_period  ? (
                                        // Normal display mode for trial rows
                                        <span>{`${d.trial_period} Months`}</span>
                                      ) : (
                                        <span>-</span>
                                      ),
                                    <span>
                                        {d?.created_at || d?.createdAt
                                            ? moment(d.created_at || d.createdAt).format('YYYY-MM-DD')
                                            : '-'}
                                    </span>,
                                    <div
                                        style={{
                                            color:
                                                d?.status === 'Inprogress'
                                                    ? 'orange'
                                                    : d?.status === 'Rejected'
                                                        ? 'red'
                                                        : 'green',
                                        }}
                                    >
                                        {d?.status}
                                    </div>,
                                    // <span
                                    //     style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
                                    //     onClick={() => {
                                    //         setOpen(true);
                                    //         setPreviewData({
                                    //             ...d,
                                    //             practice_owner_name: `${d.practice_owner_first_name} ${d.practice_owner_last_name}`,
                                    //             point_of_contact: `${d.point_of_contact_first_name} ${d.point_of_contact_last_name}`,
                                    //             signature: d.url,
                                    //             thrivesignatureLink: d.thrivesignatureLink,
                                    //             thrivesignaturetermconditionLink: d.thrivesignaturetermconditionLink,
                                    //             signaturebase64: d.signature_sign_base64
                                    //         });
                                    //     }}
                                    // >
                                    //     View
                                    // </span>,
                                    <a
                                        key={i}
                                        style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
                                        onClick={() => {
                                            setImageType(d?.url);
                                            setOpenModal(true);
                                        }}
                                    >
                                        {t("View")}
                                    </a>,
                                    d?.hsd_sync_date || '-',
                                    <VisibilityOutlinedIcon
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setReadOnlyDialogObj({ open: true, obj: { activeStep: d?.active_step, requestId: d?.id, shipto: d?.henry_schein_account_number,plan:d?.subscription_plan, status: d?.status }, index: null })}
                                    />
                                ])}
                                offset={offset}
                                count={
                                    (count / 10) % 1 === 0
                                        ? Math.floor(count / 10)
                                        : Math.floor(count / 10 + 1)
                                }
                                handlePagination={handlePagination}
                            />}
                        {openModal && (
                            <Modal
                                className={classes.modal}
                                open={openModal}
                                onClose={handlepdfClose}
                                closeAfterTransition
                                BackdropComponent={Backdrop}
                                BackdropProps={{
                                    timeout: 300,
                                }}
                            >
                                <Fade in={openModal} timeout={300} className={classes.img}>

                                    <iframe src={imageType} width='800' height='600'></iframe>

                                </Fade>
                            </Modal>
                        )}
                    </Grid>
                </Grid>
            </Loader>

            <PreviewToPdf open={open} formFields={formFields} formData={previewData} onClose={handleClose} />
        </React.Fragment>
    );
}

function PendingRequests({ dialogObj, setDialogObj, shiptoCreatedByAdmin, setShiptoCreatedByAdmin }) {
    const [offset, setOffset] = useState(1);
    const [count, setCount] = useState(0);
    const [searchValue, setSearchValue] = useState('');
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [resLoaded, setResLoaded] = useState(false);
    const { t, i18n } = useTranslation();

    const { getPending, searchPending } = ThriveSignatureRequests();
    const { dispatch, state } = useContext(context);
    const [open, setOpen] = useState(false);
    const [previewData, setPreviewData] = useState({});
    const [filterCard, setFilterCard] = useState(false);
    const classes = Styles();
    const [logData, setLogData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [imageType, setImageType] = useState('');

    const [states, setStates] = useState({
        historyLoader: false,
        clearSearch: false,
        status: "",
        plan: "",
        filter: false
    });

    const searchBounceValues = useDebounce(() => {
        return searchValue === '' ? '' : searchValue;
    });

    useEffect(() => {
        // Optional: update pathname globally
        // dispatch({ type: 'SET_PATHNAME', payload: ['HOME', 'ADMIN', 'RESPONSE'] });
        handleGet();
    }, []);

    useEffect(() => {
        if(shiptoCreatedByAdmin) {
            setSearchValue(shiptoCreatedByAdmin);            
        }
    },[])

    useEffect(() => {
        if (states?.clearSearch) {
            setStates((prev) => ({ ...prev, clearSearch: false }));
            return;
        }

        if (searchBounceValues && searchBounceValues.length > 0) {
            handleSearch();
        } else {
            handleGet();
        }
    }, [searchBounceValues, offset, states?.filter]);

    const handlepdfClose = () => {
        setOpenModal(false);
    }

    const getPlanName = (plan) => {
        if (!plan) return "-";
        const index = plan.indexOf(":");
        const substring = index === -1 ? plan : plan.substring(0, index);
        return substring.split(" ")[0].trim();
    }

    const handlePagination = (value) => {
        setOffset(value);
    };

    const handleGet = async () => {
        setLoading(true);
        try {
            let values;
            values = {
                offset: (offset - 1) * 10,
                limit: 10,
            };

            const res = await getPending(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
        } catch (e) {
            console.error('Get error:', e);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = async () => {
        setLoading(true);
        try {
            const values = {
                search: searchValue,
                offset: (offset - 1) * 10,
                limit: 10
            };
            const res = await searchPending(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
            if(shiptoCreatedByAdmin) {
                let data = res.data[0];
                setDialogObj({ open: true, obj: { activeStep: data?.active_step - 1, requestId: data?.id, shipto: data?.henry_schein_account_number, plan: data?.subscription_plan,handleGet ,email: data?.email}, index: null,email: data?.email });
                setShiptoCreatedByAdmin('');
            }
        } catch (e) {
            console.error('Search error:', e);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setOpen(false);
    }

    return (
        <React.Fragment>
            <Grid container className={classes.root}>
                <Grid item xs={12} sm={12} lg={12} style={{ position: 'relative' }}>
                    <CssTextField
                        placeholder={'Search for Shipto'}
                        type={'text'}
                        variant='outlined'
                        onKeyDown={blockInvalidChar}
                        className={classes.searchInput}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position='end'>
                                    {searchValue.length > 0 ? (
                                        <CloseOutlinedIcon
                                            className={classes.searchInputIcon}
                                            onClick={() => {
                                                setSearchValue('');
                                                setOffset(1);
                                                handleGet();
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src={searchIcon}
                                            alt=''
                                            width='20px'
                                            className={classes.searchInputIcon}
                                        />
                                    )}
                                </InputAdornment>
                            )
                        }}
                        value={searchValue}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            setOffset(1);
                            if (e.target.value.length === 0) {
                                handleGet();
                            }
                        }}
                    />
                </Grid>
            </Grid>

            <Loader loading={state?.loading} top='15%'>
                <Grid className={classes.tableDownInResponsive}>
                    <Grid item xs={12}>
                        {
                            loading ? (
                                <div
                                    style={{
                                        height: "25vh",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <h2>{t('Loading...')}</h2>
                                </div>

                            ) :
                                <Table
                                    headings={['Shipto', 'Account Name', 'City', 'Email', 'Segment', 'Plan', 'Trial Period','Request Date', 'Status', 'Document', 'View']}
                                    data={data.map((d, i) => [
                                        d?.henry_schein_account_number,
                                        d?.practice_name,
                                        d?.city,
                                        d?.email,
                                        d?.segment_code || "-",
                                        <span>{getPlanName(d?.subscription_plan)}</span>,
                                        d?.trial_period  ? (
                                            // Normal display mode for trial rows
                                            <span>{`${d.trial_period} Months`}</span>
                                          ) : (
                                            <span>-</span>
                                          ),
                                        <span>
                                            {d?.created_at || d?.createdAt
                                                ? moment(d.created_at || d.createdAt).format('YYYY-MM-DD')
                                                : '-'}
                                        </span>,
                                        <div style={d?.status == "Inprogress" ? { color: 'orange' } : { color: 'green' }}>{d?.status}</div>,
                                        // <span
                                        //     style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
                                        //     onClick={() => {
                                        //         setOpen(true);
                                        //         setPreviewData({
                                        //             ...d,
                                        //             practice_owner_name: `${d.practice_owner_first_name} ${d.practice_owner_last_name}`,
                                        //             point_of_contact: `${d.point_of_contact_first_name} ${d.point_of_contact_last_name}`,
                                        //             signature: d.url,
                                        //             thrivesignatureLink: d.thrivesignatureLink,
                                        //             thrivesignaturetermconditionLink: d.thrivesignaturetermconditionLink,
                                        //             signaturebase64: d.signature_sign_base64
                                        //         });
                                        //     }}
                                        // >
                                        //     View
                                        // </span>,
                                        <a
                                            key={i}
                                            style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
                                            onClick={() => {
                                                setImageType(d?.url);
                                                setOpenModal(true);
                                            }}
                                        >
                                            {t("View")}
                                        </a>,

                                        <VisibilityOutlinedIcon
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setDialogObj({ open: true, obj: { activeStep: d?.active_step - 1, requestId: d?.id, shipto: d?.henry_schein_account_number, plan:d?.subscription_plan,handleGet ,email:d?.email}, index: null,email:d?.email })}
                                        />
                                    ])}

                                    offset={offset}
                                    count={
                                        (count / 10) % 1 === 0
                                            ? Math.floor(count / 10)
                                            : Math.floor(count / 10 + 1)
                                    }
                                    handlePagination={handlePagination}
                                />}
                        {openModal && (
                            <Modal
                                className={classes.modal}
                                open={openModal}
                                onClose={handlepdfClose}
                                closeAfterTransition
                                BackdropComponent={Backdrop}
                                BackdropProps={{
                                    timeout: 300,
                                }}
                            >
                                <Fade in={openModal} timeout={300} className={classes.img}>

                                    <iframe src={imageType} width='800' height='600'></iframe>

                                </Fade>
                            </Modal>
                        )}
                    </Grid>
                </Grid>
            </Loader>

            <PreviewToPdf open={open} formFields={formFields} formData={previewData} onClose={handleClose} />
        </React.Fragment>
    );
}

function BillingSetting({ dialogObj, setDialogObj, shiptoCreatedByAdmin, setShiptoCreatedByAdmin }) {
    const [offset, setOffset] = useState(1);
    const [count, setCount] = useState(0);
    const [searchValue, setSearchValue] = useState('');
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [resLoaded, setResLoaded] = useState(false);
    const { t, i18n } = useTranslation();

    const { getbillingrecord,billingdateenrollment, billingenrollmentsearchAPI } = ThriveSignatureRequests();
    const { dispatch, state } = useContext(context);
    const [open, setOpen] = useState(false);
    const [previewData, setPreviewData] = useState({});
    const [filterCard, setFilterCard] = useState(false);
    const classes = Styles();
    const [logData, setLogData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [imageType, setImageType] = useState('');
    const locale = i18n.language == 'fr' ? fr : enUS;
    const [billingDates, setBillingDates] = useState({});
    const [savingId, setSavingId] = useState(null);

    const [states, setStates] = useState({
        historyLoader: false,
        clearSearch: false,
        status: "",
        plan: "",
        filter: false
    });

    const searchBounceValues = useDebounce(() => {
        return searchValue === '' ? '' : searchValue;
    });

    useEffect(() => {
        // Optional: update pathname globally
        // dispatch({ type: 'SET_PATHNAME', payload: ['HOME', 'ADMIN', 'RESPONSE'] });
        handleGet();
    }, [offset]);

    useEffect(() => {
        if(shiptoCreatedByAdmin) {
            setSearchValue(shiptoCreatedByAdmin);            
        }
    },[])

    useEffect(() => {
        if (states?.clearSearch) {
            setStates((prev) => ({ ...prev, clearSearch: false }));
            return;
        }

        if (searchBounceValues && searchBounceValues.length > 0) {
            handleSearch();
        } else {
            handleGet();
        }
    }, [searchBounceValues, offset, states?.filter]);

    const handlepdfClose = () => {
        setOpenModal(false);
    }

    const getPlanName = (plan) => {
        if (!plan) return "-";
        const index = plan.indexOf(":");
        const substring = index === -1 ? plan : plan.substring(0, index);
        return substring.split(" ")[0].trim();
    }

    const handlePagination = (value) => {
        setOffset(value);
    };

    const handleGet = async () => {
        setLoading(true);
        try {
            let values;
            values = {
                  offset: (offset - 1) * 10,
                    limit: 10,
            };

            const res = await getbillingrecord(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
        } catch (e) {
            console.error('Get error:', e);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = async () => {
        setLoading(true);
        try {
            const values = {
                search: searchValue,
                offset: (offset - 1) * 10,
                limit: 10
            };
            const res = await billingenrollmentsearchAPI(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
           
        } catch (e) {
            console.error('Search error:', e);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setOpen(false);
    }

    const handleSaveBillingDate = async (row) => {
       const selectedDate =
        billingDates[row.id] || new Date();

        //  const selectedDate =
        // billingDates[row.id];

    // if (!selectedDate) {
    //       return toast.error('Please select the date');
    //     return;
    // }

    try {
        setSavingId(row.id);

        const payload = {
            id: row.id,
            shipto: row.henry_schein_account_number,
            billingDate: moment(selectedDate).format("YYYY-MM-DD"),
        };

        const res = await billingdateenrollment(payload);

        if (res?.result_status === "1") {
             handleGet();
        return toast.success(res.message);

     }
    } catch (e) {
        console.error("Save billing date error:", e);
         handleGet();
         
    } finally {
         handleGet();
         
        setSavingId(null);
    }
};

    return (
        <React.Fragment>
            <Grid container className={classes.root}>
                <Grid item xs={12} sm={12} lg={12} style={{ position: 'relative' }}>
                    <CssTextField
                        placeholder={'Search for Shipto'}
                        type={'text'}
                        variant='outlined'
                        onKeyDown={blockInvalidChar}
                        className={classes.searchInput}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position='end'>
                                    {searchValue.length > 0 ? (
                                        <CloseOutlinedIcon
                                            className={classes.searchInputIcon}
                                            onClick={() => {
                                                setSearchValue('');
                                                setOffset(1);
                                                handleGet();
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src={searchIcon}
                                            alt=''
                                            width='20px'
                                            className={classes.searchInputIcon}
                                        />
                                    )}
                                </InputAdornment>
                            )
                        }}
                        value={searchValue}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            setOffset(1);
                            if (e.target.value.length === 0) {
                                handleGet();
                            }
                        }}
                    />
                </Grid>
            </Grid>

            <Loader loading={state?.loading} top='15%'>
                <Grid className={classes.tableDownInResponsive}>
                    <Grid item xs={12}>
                        {
                            loading ? (
                                <div
                                    style={{
                                        height: "25vh",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <h2>{t('Loading...')}</h2>
                                </div>

                            ) :
                                  <Table
                                    headings={['Shipto', 'AccountName',  'Email', 'Plan','RequestDate' , 'Status', 'SetDate']}
                                    data={data.map((d, i) => [
                                        d?.henry_schein_account_number,
                                        d?.practice_name,
                                        d?.email,
                                      
                                        <span>{getPlanName(d?.subscription_plan)}</span>,
                                       
                                        <span>
                                            {d?.created_at || d?.createdAt
                                                ? moment(d.created_at || d.createdAt).format('YYYY-MM-DD')
                                                : '-'}
                                        </span>,
                                        <div style={d?.status == "Inprogress" ? { color: 'orange' } : { color: 'green' }}>{d?.status}</div>,
                                        <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                    }}
                                >
                                    <MuiPickersUtilsProvider
                                        utils={DateFnsUtils}
                                        locale={locale}
                                    >
                                        <KeyboardDatePicker
                                            disableToolbar
                                            name="billingDate"
                                            inputVariant="outlined"
                                            format={
                                                i18n.language === "en"
                                                    ? "MM/dd/yyyy"
                                                    : "dd/MM/yyyy"
                                            }
                                            margin="normal"
                                            id={`billing-date-picker-${d?.id}`}
                                            style={{
                                                width: "190px",
                                                margin: "0px",
                                            }}
                                            value={billingDates[d?.id] ||new Date()}
                                            //  value={null}
                                            minDate={d?.created_at}
                                           onChange={(date) => {
                                                setBillingDates(prev => ({
                                                    ...prev,
                                                    [d.id]: date
                                                }));
                                            }}
                                            autoOk
                                        />
                                    </MuiPickersUtilsProvider>

                                    <Button style ={{background:"#0a72ba",color:"white"}}
                                        variant="contained"
                                        size="small"
                                        // disabled={
                                        //     !billingDates[d?.id] ||
                                        //     savingId === d?.id
                                        // }
                                        onClick={() => handleSaveBillingDate(d)}
                                    >
                                        {savingId === d?.id ? "Saving..." : "Save"}
                                    </Button>
                                </div>
                                       
                                       

                                       
                                    ])}

                                    offset={offset}
                                    count={
                                        (count / 10) % 1 === 0
                                            ? Math.floor(count / 10)
                                            : Math.floor(count / 10 + 1)
                                    }
                                    handlePagination={handlePagination}
                                />}
                        {openModal && (
                            <Modal
                                className={classes.modal}
                                open={openModal}
                                onClose={handlepdfClose}
                                closeAfterTransition
                                BackdropComponent={Backdrop}
                                BackdropProps={{
                                    timeout: 300,
                                }}
                            >
                                <Fade in={openModal} timeout={300} className={classes.img}>

                                    <iframe src={imageType} width='800' height='600'></iframe>

                                </Fade>
                            </Modal>
                        )}
                    </Grid>
                </Grid>
            </Loader>

            <PreviewToPdf open={open} formFields={formFields} formData={previewData} onClose={handleClose} />
        </React.Fragment>
    );
}

function AddOnPlanSetting({ dialogObj, setDialogObj, shiptoCreatedByAdmin, setShiptoCreatedByAdmin }) {
    const [offset, setOffset] = useState(1);
    const [count, setCount] = useState(0);
    const [searchValue, setSearchValue] = useState('');
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [resLoaded, setResLoaded] = useState(false);
    const { t, i18n } = useTranslation();

    const {  getaddplanrecord,
    addplanenrollmentsearchAPI,addOnPlansMappingApi } = ThriveSignatureRequests();
    const { dispatch, state } = useContext(context);
    const [open, setOpen] = useState(false);
    const [previewData, setPreviewData] = useState({});
    const [filterCard, setFilterCard] = useState(false);
    const classes = Styles();
    const [logData, setLogData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [imageType, setImageType] = useState('');
    const locale = i18n.language == 'fr' ? fr : enUS;
    const [billingDates, setBillingDates] = useState({});
    const [savingId, setSavingId] = useState(null);

    const [salesPlan, setSalesPlan] = useState({});
    const [freeFreight, setFreeFreight] = useState({});


   

    const [states, setStates] = useState({
        historyLoader: false,
        clearSearch: false,
        status: "",
        plan: "",
        filter: false
    });

    const searchBounceValues = useDebounce(() => {
        return searchValue === '' ? '' : searchValue;
    });

    useEffect(() => {
        // Optional: update pathname globally
        // dispatch({ type: 'SET_PATHNAME', payload: ['HOME', 'ADMIN', 'RESPONSE'] });
        handleGet();
    }, [offset]);

    useEffect(() => {
        if(shiptoCreatedByAdmin) {
            setSearchValue(shiptoCreatedByAdmin);            
        }
    },[])

    useEffect(() => {
        if (states?.clearSearch) {
            setStates((prev) => ({ ...prev, clearSearch: false }));
            return;
        }

        if (searchBounceValues && searchBounceValues.length > 0) {
            handleSearch();
        } else {
            handleGet();
        }
    }, [searchBounceValues, offset, states?.filter]);

    const handlepdfClose = () => {
        setOpenModal(false);
    }

    const getPlanName = (plan) => {
        if (!plan) return "-";
        const index = plan.indexOf(":");
        const substring = index === -1 ? plan : plan.substring(0, index);
        return substring.split(" ")[0].trim();
    }

    const handlePagination = (value) => {
        setOffset(value);
    };

    const handleGet = async () => {
        setLoading(true);
        try {
            let values;
            values = {
                  offset: (offset - 1) * 10,
                    limit: 10,
            };

            const res = await getaddplanrecord(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
        } catch (e) {
            console.error('Get error:', e);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = async () => {
        setLoading(true);
        try {
            const values = {
                search: searchValue,
                offset: (offset - 1) * 10,
                limit: 10
            };
            const res = await addplanenrollmentsearchAPI(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
           
        } catch (e) {
            console.error('Search error:', e);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setOpen(false);
    }

    const handleAddonPlans = async (d) => {
    try {
        setSavingId(d?.id);

        const payload = {
            requestId: d?.id,
            salesPlan: salesPlan[d?.id] || 'Skip',
            freeFreight: freeFreight[d?.id] || 'Apply',
            shipto: d?.henry_schein_account_number,
        };

        console.log("Save payload:", payload);

        const res = await addOnPlansMappingApi(payload);

        if (res) {
            toast.success("Add-on Plans saved successfully.");
            handleGet();
        }

    } catch (e) {
        console.error("API error:", e);
        toast.error("An error occurred while submitting Add-on Plans.");
    } finally {
        setSavingId(null);
    }
};

//     const handleSaveBillingDate = async (row) => {
//        const selectedDate =
//         billingDates[row.id] || new Date();

//     // if (!selectedDate) {
//     //       return toast.error('Please select the date');
//     //     return;
//     // }

//     try {
//         setSavingId(row.id);

//         const payload = {
//             id: row.id,
//             shipto: row.henry_schein_account_number,
//             billingDate: moment(selectedDate).format("YYYY-MM-DD"),
//         };

//         const res = await billingdateenrollment(payload);

//         if (res?.result_status === "1") {
//              handleGet();
//         return toast.success(res.message);

//      }
//     } catch (e) {
//         console.error("Save billing date error:", e);
//          handleGet();
         
//     } finally {
//          handleGet();
         
//         setSavingId(null);
//     }
// };

    return (
        <React.Fragment>
            <Grid container className={classes.root}>
                <Grid item xs={12} sm={12} lg={12} style={{ position: 'relative' }}>
                    <CssTextField
                        placeholder={'Search for Shipto'}
                        type={'text'}
                        variant='outlined'
                        onKeyDown={blockInvalidChar}
                        className={classes.searchInput}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position='end'>
                                    {searchValue.length > 0 ? (
                                        <CloseOutlinedIcon
                                            className={classes.searchInputIcon}
                                            onClick={() => {
                                                setSearchValue('');
                                                setOffset(1);
                                                handleGet();
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src={searchIcon}
                                            alt=''
                                            width='20px'
                                            className={classes.searchInputIcon}
                                        />
                                    )}
                                </InputAdornment>
                            )
                        }}
                        value={searchValue}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            setOffset(1);
                            if (e.target.value.length === 0) {
                                handleGet();
                            }
                        }}
                    />
                </Grid>
            </Grid>

            <Loader loading={state?.loading} top='15%'>
                <Grid className={classes.tableDownInResponsive}>
                    <Grid item xs={12}>
                        {
                            loading ? (
                                <div
                                    style={{
                                        height: "25vh",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <h2>{t('Loading...')}</h2>
                                </div>

                            ) :
                                 <Table
                                    headings={[
                                        'Shipto',
                                        'AccountName',
                                        'Email',
                                        'Plan',
                                        'RequestDate',
                                        'Status',
                                        'SalesPlan',
                                        'FF/Surcharge',
                                        'Action'
                                    ]}
                                    data={data.map((d, i) => [
                                        d?.henry_schein_account_number,

                                        d?.practice_name,

                                        d?.email,

                                        <span>
                                            {getPlanName(d?.subscription_plan)}
                                        </span>,

                                        <span>
                                            {d?.created_at || d?.createdAt
                                                ? moment(
                                                    d.created_at || d.createdAt
                                                ).format('YYYY-MM-DD')
                                                : '-'}
                                        </span>,

                                        <div
                                            style={
                                                d?.status === "Inprogress"
                                                    ? { color: 'orange' }
                                                    : { color: 'green' }
                                            }
                                        >
                                            {d?.status}
                                        </div>,

                                        // Sales Plan
                                        <div>
                                            {['Apply', 'Skip'].map(v => (
                                                <label
                                                    key={v}
                                                    style={{ display: 'block',
                                                    marginBottom: '4px',
                                                    cursor: 'pointer' }}
                                                >
                                                    <input
                                                        type="radio"
                                                        name={`salesPlan-${d?.id}`}
                                                        value={v}
                                                        checked={
                                                            (salesPlan[d?.id] || 'Skip') === v
                                                        }
                                                        onChange={() => {
                                                            setSalesPlan(prev => ({
                                                                ...prev,
                                                                [d?.id]: v
                                                            }));
                                                        }}
                                                    />
                                                    {' '}{v}
                                                </label>
                                            ))}
                                        </div>,

                                        // FF / Surcharge
                                        <div>
                                            {['Apply', 'Skip'].map(v => (
                                                <label
                                                    key={v}
                                                     style={{
                                                        display: 'block',
                                                        marginBottom: '4px',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    <input
                                                        type="radio"
                                                        name={`freeFreight-${d?.id}`}
                                                        value={v}
                                                        checked={
                                                            (freeFreight[d?.id] || 'Apply') === v
                                                        }
                                                        onChange={() => {
                                                            setFreeFreight(prev => ({
                                                                ...prev,
                                                                [d?.id]: v
                                                            }));
                                                        }}
                                                    />
                                                    {' '}{v}
                                                </label>
                                            ))}
                                        </div>,

                                        // Save
                                        <Button
                                            variant="contained"
                                            size="small"
                                            style={{
                                                background: "#0a72ba",
                                                color: "white"
                                            }}
                                             onClick={() => handleAddonPlans(d)}
                                        >
                                            {savingId === d?.id ? "Saving..." : "Save"}
                                        </Button>
                                    ])}

                                    offset={offset}

                                    count={
                                        (count / 10) % 1 === 0
                                            ? Math.floor(count / 10)
                                            : Math.floor(count / 10 + 1)
                                    }

                                    handlePagination={handlePagination}
                                />}
                        {openModal && (
                            <Modal
                                className={classes.modal}
                                open={openModal}
                                onClose={handlepdfClose}
                                closeAfterTransition
                                BackdropComponent={Backdrop}
                                BackdropProps={{
                                    timeout: 300,
                                }}
                            >
                                <Fade in={openModal} timeout={300} className={classes.img}>

                                    <iframe src={imageType} width='800' height='600'></iframe>

                                </Fade>
                            </Modal>
                        )}
                    </Grid>
                </Grid>
            </Loader>

            <PreviewToPdf open={open} formFields={formFields} formData={previewData} onClose={handleClose} />
        </React.Fragment>
    );
}


export default function SignatureEnrollments() {
    const [value, setValue] = useState(1);
    const [shiptoCreatedByAdmin, setShiptoCreatedByAdmin] = useState('');
    const { upload, getsignature, getShiptoDetailsByShipto, updateEmail } = ThriveSignatureRequests();
    const [offset, setOffset] = useState(1);
    const [count, setCount] = useState(0);

    const [data, setData] = useState([]);
    const classes = Styles();
    const [dialogObj, setDialogObj] = useState({
        open: false,
        obj: {},
        index: null,
    });
    const [readOnlyDialogObj, setReadOnlyDialogObj] = useState({
        open: false,
        obj: {},
        index: null,
    });
    const [createDialogObj, setCreateDialogObj] = useState({
        open: false,
        obj: {},
        index: null,
    });
    const [editEmailField, setEditEmailField] = useState({
        isModalOpen: false,
        loading: false,
        shipto: '',
        edittedShipto: '',
        accountName: '',
        originalCustomerEmail: '',
        customerEmail: '',
        isEditCustomerEmail: false,
        editedCustomerEmail: '',
        editIndex: null,
        originalFscEmail: [],
        fscEmail: [],        
    });
    const i18n = useTranslation();
    const locale = i18n.language == 'fr' ? fr : enUS;
    const [paymentPlan, setPaymentPlan] = useState('');

    const components = [
        <AllRequests readOnlyDialogObj={readOnlyDialogObj} setReadOnlyDialogObj={setReadOnlyDialogObj} setCreateDialogObj={setCreateDialogObj} setEditEmailField={setEditEmailField} />,
        <PendingRequests dialogObj={dialogObj} setDialogObj={setDialogObj} shiptoCreatedByAdmin={shiptoCreatedByAdmin} setShiptoCreatedByAdmin={setShiptoCreatedByAdmin} />,
        <BillingSetting  />,
        <AddOnPlanSetting  />
    ];

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState("");
    const [shipto, setshipto] = useState("");
    const [plan, setplan] = useState("");
    const [showPeriodDropdown, setShowPeriodDropdown] = useState(false);
    const [trialperiod, settrialperiod] = useState("");
    const [promoCode, setPromoCode] = useState("");
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const fileInputRef = useRef(null);

    const handleGet = async () => {
        setLoading(true);
        try {
            let values;
            values = {
                offset: (offset - 1) * 10,
                limit: 10,
            };

            const res = await getsignature(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
            }
        } catch (e) {
            console.error('Get error:', e);
        } finally {
            setLoading(false);
        }
    };


    const handleFileChange = (event) => {
        const selectedFile = event.target.files?.[0];
        if (selectedFile) {
            setFile(selectedFile);
            setFileName(selectedFile.name);
        }
    };

    const handleclose = (event) => {

        setFile(null);
        setFileName("");
        setCreateDialogObj({ ...createDialogObj, open: false })
        setshipto("")
        setplan("")
        settrialperiod("")
        setPromoCode("")
        if (fileInputRef.current) fileInputRef.current.value = "";

    };

    const handleUpload = async () => {
        if (!shipto || !plan) {
            toast.error("please Select all field");
            return;
        }
        if (!file) {
            toast.error("Enrollment Form required. Please upload the file.");
            return;
        }

        if (file.type !== "application/pdf") {
            toast.error("Only PDF documents are accepted. Please upload accordingly.");
            return;
        }

        if(plan==="Trial" && !trialperiod){
            toast.error("Please select the Trial Period");
            return;

        }
setLoading(true)
        const formData = new FormData();
        formData.append("file", file);
        formData.append("shipto", shipto);
        formData.append("plan", plan);
        formData.append("trialperiod", trialperiod);
        formData.append("promoCode", promoCode.trim());

        try {
            let res = await upload(formData);
            // console.log(res)
            if (res.result_status == '1') {
                setLoading(false)
                setFile(null);
                setFileName("");
                setCreateDialogObj({ ...createDialogObj, open: false })
                setshipto("")
                setplan("")
                settrialperiod("")
                setPromoCode("")
                setShiptoCreatedByAdmin(shipto);
                setValue(1);
                if (fileInputRef.current) fileInputRef.current.value = "";
                handleGet()
                return toast.success(res.message);



            }
            else {
                setLoading(false)

                toast.error(res.message)
            }
            //   setResult(res.data);
        } catch (err) {
            console.error(err);
            setLoading(false);
            toast.error("Failed to upload PDF!");
        } finally {
            //   setLoading(false);
                setLoading(false)

        }
    };
   

    // if (plan === "Trial") {
    //     setShowPeriodDropdown(true);
    //   } else {
    //     setShowPeriodDropdown(false); 
    //   }

    
    
  

    return (
        <>
            <Box>
                <Tabs value={value} onChange={handleChange} aria-label="Thrive Signature Enrollment"
                    TabIndicatorProps={{
                        style: { backgroundColor: '#007bff' }, // e.g., '#1976d2' for blue
                    }}>
                    <Tab label="All Requests" />
                    <Tab label="My Pending Requests" />
                     <Tab label="Billing Date Setting" />
                     <Tab label="Add On Plan Setting" />
                </Tabs>
                <Box sx={{ p: 2 }}>
                    {components[value]}
                </Box>
            </Box>

            <Dialog
                open={dialogObj?.open}
                onClose={() => setDialogObj({ open: false, obj: {}, index: null })}
                maxWidth={false}
                PaperProps={{
                    style: {
                        width: "600px",
                        borderRadius: "12px",
                        fontFamily: "Segoe UI",
                    }
                }}
            >
                <IconButton
                    aria-label="close"
                    onClick={() => setDialogObj({ open: false, obj: {}, index: null })}
                    style={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: '#888',
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <div
  style={{
    fontSize: 16,
    fontWeight: 600,
    margin: "10px 0px 0px 20px",
    padding: "2px 10px",
    border: "1px solid #ddd",
    borderRadius: "5px",
    background: "grey",
    color: "#fff",
    display: "flex",
    width: "141px"
   
  }}
>
{
  ['yearly', 'monthly', 'trial'].some(item =>
    String(dialogObj?.obj?.plan).toLowerCase().includes(item)
  )
    ? 'Thrive Signature'
    : 'Thrive Unlocked'
}
</div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                
                    <div style={{ fontSize: 16, fontWeight: 600, margin: "10px 0px 0px 20px", padding: "2px 10px", border: "1px solid #ddd", borderRadius: "5px", background: "grey", color: "#fff" }}>Shipto: {dialogObj?.obj?.shipto}</div>
                   
                    {/* <div style={{ fontSize: 16, fontWeight: 600, margin: "10px 60px 0px 0px" }}>Enrollment Date: Jan-01-2025</div> */}
                </div>
                <div style={{ padding: 20 }}>
                    <VerticalLinearStepper activeStep={dialogObj?.obj?.activeStep} setDialogObj={setDialogObj} requestId={dialogObj?.obj?.requestId} shipto={dialogObj?.obj?.shipto} handleGet={dialogObj?.obj?.handleGet} email={dialogObj?.obj?.email} plan={dialogObj?.obj?.plan}/>
                </div>
            </Dialog>

            <Dialog
                open={readOnlyDialogObj?.open}
                onClose={() => setReadOnlyDialogObj({ open: false, obj: {}, index: null })}
                maxWidth={false}
                PaperProps={{
                    style: {
                        width: "90%",
                        borderRadius: "12px",
                        fontFamily: "Segoe UI",
                        height: "100vh",
                        background: "rgb(245,245,245)"
                    },
                }}
            >
                <IconButton
                    aria-label="close"
                    onClick={() => setReadOnlyDialogObj({ open: false, obj: {}, index: null })}
                    style={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: '#888',
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <div
  style={{
    fontSize: 16,
    fontWeight: 600,
    margin: "10px 0px 0px 20px",
    padding: "2px 10px",
    border: "1px solid #ddd",
    borderRadius: "5px",
    background: "grey",
    color: "#fff",
    display: "flex",
    width: "141px"
   
  }}
>
{
  ['yearly', 'monthly', 'trial'].some(item =>
    String(readOnlyDialogObj?.obj?.plan).toLowerCase().includes(item)
  )
    ? 'Thrive Signature'
    : 'Thrive Unlocked'
}
</div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    
                    <div style={{ fontSize: 16, fontWeight: 600, margin: "10px 0px 0px 20px", padding: "2px 10px", border: "1px solid #ddd", borderRadius: "5px", background: "grey", color: "#fff" }}>Shipto: {readOnlyDialogObj?.obj?.shipto}</div>

                    {/* <Box
    style={{
        display: "flex",
        alignItems: "center",
        gap: "20px",
        marginBottom: "15px",
        marginRight :"60px"
    }}
>
    {[
        { label: "Completed", color: "#4caf50" },
        { label: "Current Step", color: "#2196f3" },
        { label: "Incomplete", color: "#bdbdbd" },
    ].map((item) => (
        <Box
            key={item.label}
            style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
            }}
        >
            <Box
                style={{
                    width: "12px",
                    height: "12px",
                    backgroundColor: item.color,
                    borderRadius: "3px",
                }}
            />
            <span style={{ fontSize: "13px" }}>
                {item.label}
            </span>
        </Box>
    ))}
</Box> */}
                    {/* <div style={{  fontSize: 16, fontWeight: 600, margin: "10px 60px 0px 0px" }}>Enrollment Date: Jan-01-2025</div> */}
                </div>

                <div style={{ padding: 20 }}>
                    <HorizontalStepperForEnrollment activeStep={readOnlyDialogObj?.obj?.activeStep} requestId={readOnlyDialogObj?.obj?.requestId} status={readOnlyDialogObj?.obj?.status} plan={readOnlyDialogObj?.obj?.plan}/>
                </div>
            </Dialog>
            <Dialog
                open={createDialogObj?.open}
                keepMounted
                onClose={() => setCreateDialogObj({ ...createDialogObj, open: false })}
                aria-describedby='alert-dialog-slide-description'
                fullWidth
                maxWidth='xs'
                disableBackdropClick
            >
                <DialogContent>
                    <CloseOutlinedIcon
                        className={classes.closeIcon}
                        onClick={handleclose}
                    />
                    <div
                        style={{
                            fontSize: 20,
                            fontWeight: 'bold',
                            textAlign: 'center',
                            margin: "15px 0px",
                        }}
                    >
                        {'Create New Request'}
                    </div>
                    <DialogContentText id='alert-dialog-slide-description'>
                        <Grid container item xs={12} spacing={2}>
                            {/* Shipto Field */}
                            <Grid item xs={12}>

                                <TextField
                                    id="Plan"
                                    label={
                                        <span>
                                            {t('Shipto')} <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }

                                    fullWidth
                                    type="text"
                                    value={shipto}
                                    onChange={(e) => {
                                        setshipto(e.target.value);
                                    }}
                                >

                                </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="Plan"
                                    label={
                                        <span>
                                            {t('Plan')} <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    select
                                    fullWidth
                                    type="text"
                                    value={plan}
                                    onChange={(e) => {
                                        setplan(e.target.value);
                                    }}
                                >
                                    <MenuItem value="Yearly">{t('Yearly')}</MenuItem>
                                    <MenuItem value="Monthly">{t('Monthly')}</MenuItem>
                                    <MenuItem value="Trial">{t('Trial')}</MenuItem>
                                    <MenuItem value="Unlocked">{t('Unlocked')}</MenuItem>
                                </TextField>
                            </Grid>
                            

                                    {plan === "Trial" && (

                                        <Grid item xs={12}>

                                            <TextField
                                    id="Plan"
                                    label={
                                        <span>
                                            {t('Trial Period')} <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    select
                                    fullWidth
                                    type="text"
                                    value={trialperiod}
                                    onChange={(e) => {
                                        settrialperiod(e.target.value);
                                    }}
                                >
                                    <MenuItem value="3">{t("3 Months")}</MenuItem>
                                    <MenuItem value="4">{t("4 Months")}</MenuItem>
                                    <MenuItem value="5">{t("5 Months")}</MenuItem>
                                    <MenuItem value="6">{t("6 Months")}</MenuItem>
                                </TextField>
                                </Grid>
                                  )}

                            {/* Promo Code Field (optional, all plans) */}
                            <Grid item xs={12}>
                                <TextField
                                    id="PromoCode"
                                    label={t('Promo Code (Optional)')}
                                    fullWidth
                                    type="text"
                                    value={promoCode}
                                    onChange={(e) => {
                                        setPromoCode(e.target.value);
                                    }}
                                >

                                </TextField>
                            </Grid>


                            {/* File Upload Field */}
                            <Grid item xs={12}>
                                <div
                                    style={{
                                        border: "2px dashed #ccc",
                                        padding: "20px",
                                        textAlign: "center",
                                        borderRadius: "10px",
                                        position: "relative",
                                    }}

                                >
                                    <input
                                        id="demo"
                                        type="file"
                                        ref={fileInputRef}
                                        accept="application/pdf"
                                        onChange={handleFileChange}
                                        style={{
                                            position: "absolute",
                                            width: "100%",
                                            height: "100%",
                                            opacity: 0,
                                            cursor: "pointer",
                                            left: 0,
                                            top: 0,
                                        }}
                                    />

                                    {!fileName ? (
                                        <p>Upload the customer-submitted signed Enrollment Form (PDF). Drag & drop the file here or click to select</p>
                                    ) : (
                                        <Typography variant="body1" sx={{ pt: 1 }}>
                                            📄 <strong>{fileName}</strong>
                                        </Typography>
                                    )}
                                </div>
                            </Grid>
                        </Grid>

                        {/* Submit Button */}
                        <div style={{ marginTop: 20, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleUpload}
                                disabled={loading}
                            >
                                {loading ? "Uploading..." : "Submit"}
                            </Button>
                        </div>
                    </DialogContentText>
                </DialogContent>
            </Dialog>

            <Dialog
                open={editEmailField?.isModalOpen}
                keepMounted
                onClose={() => setEditEmailField({ ...editEmailField, isModalOpen: false })}
                aria-describedby='alert-dialog-slide-description'
                fullWidth
                maxWidth='xs'
                disableBackdropClick
            >
                <DialogContent>
                    <CloseOutlinedIcon
                        className={classes.closeIcon}
                        onClick={() => {
                            setEditEmailField({
                                isModalOpen: false,
                                loading: false,
                                shipto: '',
                                accountName: '',
                                originalCustomerEmail: '',
                                customerEmail: '',
                                isEditCustomerEmail: false,
                                editedCustomerEmail: '',
                                editIndex: null,
                                originalFscEmail: [],
                                fscEmail: [],
                                edittedShipto: ''
                            });
                        }}
                    />
                    <div
                        style={{
                            fontSize: 20,
                            fontWeight: 'bold',
                            textAlign: 'center',
                            margin: "15px 0px",
                        }}
                    >
                        {'Edit Customer / FSC Email'}
                    </div>
                    <DialogContentText id='alert-dialog-slide-description'>
                        <Grid container item xs={12} spacing={2} style={{display: 'flex', alignItems: 'center'}}>
                            {/* Shipto Field */}
                            <Grid item xs={8}>

                                <TextField
                                    id="Plan"
                                    label={
                                        <span>
                                            {t('Enter Shipto')} <span style={{ color: 'red' }}></span>
                                        </span>
                                    }

                                    fullWidth
                                    type="number"
  onWheel={(e) => e.target.blur()}
                                    value={editEmailField?.edittedShipto}
                                    onChange={(e) => {
                                        setEditEmailField({...editEmailField, edittedShipto: e.target.value, originalCustomerEmail: ''});
                                    }}
                                >
                                    
                                </TextField>
                            </Grid> 
                            <Grid item xs={4}>
                                <Button
                                    className={`${classes.filterBtn} dash-1-filter-btn`}
                                    onClick={async () => {
                                        if(editEmailField.edittedShipto == null) {
                                            return toast.warn("Please enter the shipto")
                                        }
                                        const res = await getShiptoDetailsByShipto({
                                            shipto: editEmailField.edittedShipto,
                                            type: 'signature'
                                        });

                                        if (!res?.data) {
                                            return toast.info("No records found");
                                        } else if (res.data.status === "Rejected") {
                                            return toast.error("The account is rejected");
                                        } else if (res.data.email == null) {
                                            return toast.info("Account has no email to edit");
                                        }                                       

                                        setEditEmailField((prev) => ({
                                            ...prev,
                                            shipto:
                                                res?.data?.henry_schein_account_number || '',
                                            accountName: res?.data?.practice_name || '',
                                            customerEmail: res?.data?.email || '',
                                            originalCustomerEmail: res?.data?.email || '',
                                            editedCustomerEmail:
                                                res?.data?.email || '',
                                            fscEmail: res?.data?.fsc?.value
                                                ? res?.data?.fsc?.value
                                                    .split(',')
                                                    .map((email) => email.trim())
                                                    .filter(Boolean)
                                                : [],
                                            originalFscEmail: res?.data?.fsc?.value
                                                ? res?.data?.fsc?.value
                                                    .split(',')
                                                    .map((email) => email.trim())
                                                    .filter(Boolean)
                                                : [],
                                            editIndex: null,
                                            isEditCustomerEmail: false,
                                        }));
                                    }}
                                >
                                    Search
                                </Button>

                            </Grid>                                                                                
                            {editEmailField?.originalCustomerEmail && <Grid item xs={12}>
                                <strong>Shipto: </strong>{editEmailField?.shipto}
                            </Grid>}
                            {editEmailField?.originalCustomerEmail && <Grid item xs={12}>
                                <strong>Account Name: </strong>{editEmailField?.accountName}
                            </Grid>}
                            {editEmailField?.originalCustomerEmail && <Grid item xs={12}>
                                <strong>Customer Email: </strong>

                                {editEmailField.isEditCustomerEmail ? (
                                    <>
                                        <TextField
                                            id="customer-email"
                                            type="email"                                            
                                            style={{width: "90%"}}                                            
                                            value={editEmailField.editedCustomerEmail}
                                            onChange={(e) => {
                                                setEditEmailField((prev) => ({
                                                    ...prev,
                                                    editedCustomerEmail: e.target.value,
                                                    customerEmail: e.target.value
                                                }));
                                            }}
                                        />

                                        {/* <button
                                            type="button"                                            
                                            style={{ 
                                                // marginLeft: 5, 
                                                cursor: "pointer", 
                                                marginTop: 7,
                                                border: "none",                                                
                                                width: "40px",
                                                height: "25px",
                                                borderRadius: "5px",
                                                background: "#0a72ba",
                                                color: "#fff"                                                 
                                            }}
                                            onClick={() => {
                                                setEditEmailField((prev) => ({
                                                    ...prev,                                                    
                                                    isEditCustomerEmail: false
                                                }));
                                            }}
                                        >
                                            Save
                                        </button> */}
                                    </>
                                ) : (
                                    <>
                                        <span>{editEmailField.customerEmail}</span>

                                        <button
                                            type="button"
                                            style={{ marginLeft: 5, cursor: "pointer" }}
                                            onClick={() => {
                                                setEditEmailField((prev) => ({
                                                    ...prev,
                                                    editedCustomerEmail: prev.customerEmail,
                                                    isEditCustomerEmail: true,
                                                    editIndex: null,
                                                }));
                                            }}
                                        >
                                            ✏️
                                        </button>
                                    </>
                                )}
                            </Grid>}                            
                            {editEmailField?.originalCustomerEmail && <Grid item xs={12}>
                                <strong>FSC Email:</strong>
                            </Grid>}
                            {                                    
                                editEmailField?.originalCustomerEmail && editEmailField?.fscEmail?.map((email, index) => {
                                    const isEditing = editEmailField.editIndex === index;

                                    return (
                                        <Grid item xs={12} key={index}>
                                            {isEditing ? (
                                                <>
                                                    <TextField
                                                        id={`fsc-email-${index}`}
                                                        type="email"
                                                        value={email}
                                                        style={{width: "90%"}}
                                                        onChange={(e) => {
                                                            const updatedEmails = [
                                                                ...editEmailField.fscEmail,
                                                            ];

                                                            updatedEmails[index] = e.target.value;

                                                            setEditEmailField((prev) => ({
                                                                ...prev,
                                                                fscEmail: updatedEmails,
                                                            }));
                                                        }}
                                                    />

                                                    {/* <button                                                        
                                                        style={{
                                                            // marginLeft: 5, 
                                                            cursor: "pointer", 
                                                            marginTop: 7,
                                                            border: "none",                                                
                                                            width: "40px",
                                                            height: "25px",
                                                            borderRadius: "5px",
                                                            background: "#0a72ba",
                                                            color: "#fff"                                                            
                                                        }}
                                                        onClick={() => {
                                                            setEditEmailField((prev) => ({
                                                                ...prev,
                                                                editIndex: null,
                                                            }));
                                                        }}
                                                    >
                                                        Save
                                                    </button> */}
                                                </>
                                            ) : (
                                                <>
                                                    <span>{email}</span>

                                                    <button
                                                        type="button"
                                                        style={{ marginLeft: 5, cursor: "pointer" }}
                                                        onClick={() => {
                                                            setEditEmailField((prev) => ({
                                                                ...prev,
                                                                editIndex: index,
                                                                isEditCustomerEmail: false,
                                                            }));
                                                        }}
                                                    >
                                                        ✏️
                                                    </button>
                                                </>
                                            )}
                                        </Grid>
                                    );
                                })
                            }                                                       
                            {/* Submit Button */}
                            {editEmailField?.originalCustomerEmail && <div style={{ marginTop: 20, display: 'flex', justifyContent: 'flex-end', width: "100%", alignItems: 'flex-end' }}>
                                <Button                                         
                                        style={{
                                            height: "40px",
                                            color: "#000",
                                            background: "lightgrey",
                                            borderRadius: "10px",
                                            textTransform: "none"
                                        }}
                                        onClick={() => setEditEmailField({
                                            isModalOpen: true,
                                            loading: false,
                                            shipto: '',
                                            accountName: '',
                                            originalCustomerEmail: '',
                                            customerEmail: '',
                                            isEditCustomerEmail: false,
                                            editedCustomerEmail: '',
                                            editIndex: null,
                                            originalFscEmail: [],
                                            fscEmail: [],
                                            edittedShipto: ''
                                        })}
                                    >
                                        Reset
                                </Button>
                                <Button
                                    className={`${classes.filterBtn} dash-1-filter-btn`}
                                    onClick={async () => {
                                        const {
                                            shipto,
                                            originalCustomerEmail,
                                            customerEmail,
                                            originalFscEmail = [],
                                            fscEmail = [],
                                        } = editEmailField;

                                        const isCustomerEmailChanged =
                                            originalCustomerEmail?.trim() !== customerEmail?.trim();

                                        const isFscEmailChanged =
                                            JSON.stringify(
                                                originalFscEmail.map((email) => email.trim())
                                            ) !==
                                            JSON.stringify(
                                                fscEmail.map((email) => email.trim())
                                            );

                                        if (!isCustomerEmailChanged && !isFscEmailChanged) {
                                            toast.warning('Please update at least one field.');
                                            return;
                                        }

                                        // Email validation
                                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                        if (isCustomerEmailChanged && !emailRegex.test(customerEmail?.trim() || '')) {
                                            toast.warning('Please enter a valid customer email.');
                                            return;
                                        }

                                        if (isFscEmailChanged) {
                                            const hasInvalidFscEmail = fscEmail.some(
                                                (email) => email.trim() && !emailRegex.test(email.trim() || '')
                                            );

                                            if (hasInvalidFscEmail) {
                                                toast.warning('Please enter valid FSC email(s).');
                                                return;
                                            }
                                        }                                        

                                        try {
                                            setEditEmailField(prev => ({...prev, loading: true}));
                                            const res = await updateEmail({
                                                type: "signature",
                                                shipto,
                                                ...(isCustomerEmailChanged && {
                                                    customerEmail: customerEmail.trim(),
                                                }),
                                                ...(isFscEmailChanged && {
                                                    fscEmail: fscEmail.map((email) => email.trim()),
                                                }),
                                            });

                                            if (res) {
                                                toast.success(res?.message);

                                                setEditEmailField({
                                                    isModalOpen: false,
                                                    loading: false,
                                                    shipto: '',
                                                    accountName: '',
                                                    originalCustomerEmail: '',
                                                    customerEmail: '',
                                                    isEditCustomerEmail: false,
                                                    editedCustomerEmail: '',
                                                    editIndex: null,
                                                    originalFscEmail: [],
                                                    fscEmail: [],
                                                    edittedShipto: ''
                                                });
                                            }
                                        } catch (error) {
                                            console.error('Failed to update email details:', error);
                                            toast.error('Failed to update email details.');
                                        }
                                    }}

                                    disabled={loading}
                                >
                                    {editEmailField?.loading ? "Uploading..." : "Submit"}
                                </Button>
                            </div>}                            
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
            <style>
                {`
                    .tabs {
                    background: #fff;
                    border-radius: 12px;
                    padding: 20px;
                    box-shadow: 0 4px 14px rgba(0,0,0,0.08);
                    width: 100%;
                    max-width: 900px;
                    margin: 20px auto;
                    font-family: Arial, sans-serif;
                    }
                    .tab-labels {
                    display: flex;
                    gap: 10px;
                    margin-bottom: 16px;
                    }
                    .tab-labels button {
                    padding: 10px 16px;
                    border: none;
                    border-radius: 8px;
                    background: #f0f0f0;
                    cursor: pointer;
                    font-weight: 600;
                    color: #555;
                    }
                    .tab-labels button.active {
                    background: #7c5cff;
                    color: #fff;
                    }
                    .panel {
                    padding: 10px;
                    background: #fafafa;
                    border-radius: 8px;
                    }
                    table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 10px;
                    }
                    th, td {
                    padding: 10px;
                    border-bottom: 1px solid #ddd;
                    text-align: left;
                    }
                    th {
                    background: #f5f5f5;
                    font-weight: 600;
                    }
                    .status {
                    padding: 4px 10px;
                    border-radius: 6px;
                    font-size: 0.85rem;
                    font-weight: 600;
                    color: #fff;
                    }
                    .status.active {
                    background: #28a745;
                    }
                    .status.pending {
                    background: #ffc107;
                    color: #000;
                    }
                    .action-btn {
                    padding: 6px 12px;
                    border: none;
                    border-radius: 6px;
                    background: #007bff;
                    color: #fff;
                    cursor: pointer;
                    }
                `}
            </style>
        </>
    );
}